import { DEVICE } from "constant";
import styled from "styled-components";

export const CreatingScreenContainer = styled.div`
  background-image: url(${(props) => props.bgImg});
  opacity: 0.8;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  margin-top: -175px;
`;

export const HeadlinesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 350px;

  & > :not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const Img = styled.img``;

export const DesktopLoaderContainer = styled.div`
  display: flex;
  margin-top: 56px;
  width: 100%;

  & > .MuiLinearProgress-root {
    width: 100%;
    height: 6px !important;
  }
`;

export const MobileCreatingScreenContainer = styled.div`
  background-color: white;
  padding: 50px 35px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;
`;

export const MobileContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 3%;

  @media ${DEVICE.xxs} {
    max-width: 250px;
  }
`;

export const MobileHeadlinesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 95px;
  width: 350px;
  align-items: center;

  & > :not(:last-child) {
    margin-bottom: 9px;
  }

  @media ${DEVICE.xs} {
    width: 250px;
  }

  @media ${DEVICE.xxs} {
    width: 210px;
  }
`;

export const MobileLoaderContainer = styled.div`
  display: flex;
  margin-top: 73px;
  width: 100%;

  & > .MuiLinearProgress-root {
    width: 100%;
    height: 6px !important;
  }
`;
